import { List } from 'immutable'
import { USER_DETAIL_STORE_KEY } from '..'

export const selectUser = (state) => state.user

export const selectUserData = (state) => state.user.getIn([USER_DETAIL_STORE_KEY, 'data'])

export const selectUserUuid = (state) => state.user.getIn([USER_DETAIL_STORE_KEY, 'data', 'uuid'])

export const selectUserUid = (state) => state.user.getIn([USER_DETAIL_STORE_KEY, 'data', 'uid'])

export const selectUsername = (state) =>
  state.user.getIn([USER_DETAIL_STORE_KEY, 'data', 'username'])

export const selectUserLastTransactionData = (state) =>
  state.user.getIn([USER_DETAIL_STORE_KEY, 'data', 'lastTransaction'])

export const selectUserGcsiDetailsData = (state) =>
  state.user.getIn([USER_DETAIL_STORE_KEY, 'data', 'gcsi_user'])

export const selectUserGcsiUuid = (state) =>
  state.user.getIn([USER_DETAIL_STORE_KEY, 'data', 'gcsi_user_uuid'])

export const selectUserProfiles = (state) => state.user.getIn(['profiles', 'data'])

export const selectUserAttributions = (state) => {
  const userData = state.user.getIn([USER_DETAIL_STORE_KEY, 'data'])

  return state.attributions.get(userData.get('uuid'), List())
}

export const selectUserAbuseData = (state) => state.userAbuse

export const selectChangeAccountOwnerSuccess = (state) =>
  state.user.getIn(['userDetail', 'changeAccountOwnerSuccess'])

export const selectChangeAccountOwnerError = (state) =>
  state.user.getIn(['userDetail', 'changeAccountOwnerError'])

export const selectChangeAccountOwnerData = (state) =>
  state.user.getIn(['userDetail', 'changeAccountOwnerData'])
